import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageCircle } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { adminApi, errMsg } from "@/lib/api";
import { Btn, Panel } from "@/admin/ui";

export const PriceReplyPanel = () => {
  const [text, setText] = useState("Tomato 40\nOnion 32, stock 50\nDONE");
  const [preview, setPreview] = useState(null);
  const [logs, setLogs] = useState([]);
  useEffect(() => { adminApi.get("/price-updates").then((r) => setLogs(r.data)); }, []);

  const run = async () => {
    try { setPreview((await adminApi.post("/price-reply/preview", { body: text })).data); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <Panel title="Update prices by WhatsApp reply" className="mt-6" testId="price-reply-panel">
      <p className="text-xs text-stone-500 mb-3">Reply to the 7:00 AM reminder from your summary number with one item per line, e.g. <b>Tomato 40</b> or <b>Onion 32, stock 50</b>. Send <b>DONE</b> to confirm today's prices. Try a practice message below — nothing is changed.</p>
      <div className="grid md:grid-cols-2 gap-3">
        <div className="space-y-2">
          <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={6} className="bg-white font-mono text-sm" data-testid="price-reply-input" />
          <Btn variant="outline" onClick={run} disabled={!text.trim()} data-testid="price-reply-preview-btn"><MessageCircle className="w-4 h-4 inline mr-1" />Preview reply</Btn>
        </div>
        <pre className="whitespace-pre-wrap text-sm bg-[#E7F8EE] rounded-md p-3 min-h-[9rem]" data-testid="price-reply-preview">{preview ? preview.reply : "The WhatsApp reply you'd get appears here."}</pre>
      </div>
      {logs.length > 0 && (
        <div className="mt-4 divide-y divide-stone-100" data-testid="price-updates-log">
          <p className="text-[10px] uppercase tracking-wider font-bold text-stone-500 mb-1">Recent WhatsApp updates</p>
          {logs.map((l) => (
            <div key={l.id} className="py-2 text-sm" data-testid={`price-update-${l.id}`}>
              <span className="font-semibold">{new Date(l.at).toLocaleString("en-IN")}</span>
              <span className="text-stone-500"> · {l.changes.length} updated{l.errors.length ? ` · ${l.errors.length} skipped` : ""}{l.confirmed ? " · prices confirmed" : ""}</span>
              <p className="text-xs text-stone-500">{l.changes.map((c) => `${c.name} ₹${c.old_price}→₹${c.price}`).join(", ")}</p>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
};
